(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ProgMedicationSearch', ProgMedicationSearch);

    ProgMedicationSearch.$inject = ['$resource'];

    function ProgMedicationSearch($resource) {
        var resourceUrl =  'api/_search/prog-medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
